import { Control, Option } from './controls.models';

export const emptyControl: Control = {
    id: '',
    testId: '',
    disabled: false,
    name: '',
    rules: [],
    classes: {},
};

export const emptyTextControl: Control = {
    ...emptyControl,
    type: 'Text',
    label: '',
    value: '',
};

export const emptyNumberControl: Control = {
    ...emptyControl,
    type: 'Number',
    label: '',
    value: null,
};

export const emptyIntegerControl: Control = {
    ...emptyControl,
    type: 'Integer',
    label: '',
    value: 0,
    minValue: Number.NEGATIVE_INFINITY,
    maxValue: Number.POSITIVE_INFINITY,
    placeholder: '',
};

export const emptySelectControl: Control = {
    ...emptyControl,
    type: 'Select',
    options: [],
    label: '',
    required: false,
    value: null,
    style: 'standard',
};

export const emptyCheckboxControl: Control = {
    ...emptyControl,
    type: 'Checkbox',
    label: '',
    value: false,
    checkedLabel: '',
    uncheckedLabel: '',
    disabledLabel: '',
    tooltipBody: '',
    tooltipHeader: '',
    tooltipLabel: '',
};

// export const emptyGeoControl: Control = {
//     ...emptyControl,
//     type: 'Geo',
//     label: '',
//     required: false,
//     value: {
//         displayName: '',
//         latitude: 0,
//         longitude: 0,
//     },
// };

export const emptyLabelControl: Control = {
    ...emptyControl,
    type: 'Label',
    label: '',
};

export const emptyActionControl: Control = {
    ...emptyControl,
    type: 'Action',
    label: '',
    icon: '',
    value: null,
};

export const emptyResetControl: Control = {
    ...emptyControl,
    type: 'Reset',
    label: '',
    icon: '',
    initialData: null,
    disable: false,
};

export const emptySubmitControl: Control = {
    ...emptyControl,
    type: 'Submit',
    label: '',
    icon: '',
};

export const emptyOption: Option = {
    id: '',
    value: '',
    display: '',
    data: null,
    props: null,
    disabled: false,
};
